<template>
  <div class="project_box">
      <div class="flexout top1"><span class="line"></span><span class="text">项目资料</span></div>
      <div class="flexout top2" style="margin-bottom:15px;">
       <!-- <el-date-picker
       style="width:145px;margin-right:5px;"
        v-model="date"
        type="date"
        placeholder="选择日期">
      </el-date-picker> -->
       <el-input placeholder="请输入资料名称进行搜索" v-model="FileName" @keyup.enter.native="getTList"></el-input>
      </div> 
       <div class="content">
          <!-- <div class="task_tab tab_box">
            <div :class="[taskTabIndex=='0'?'task_tabActive':'task_tabOne']" @click="changeTaskTab(0)">全部</div>
            <div :class="[taskTabIndex=='1'?'task_tabActive':'task_tabOne']" style="margin-left:24px;" @click="changeTaskTab(1)">离线</div>
            <div :class="[taskTabIndex=='2'?'task_tabActive':'task_tabOne']" style="margin-left:24px;" @click="changeTaskTab(2)">故障</div>
          </div> -->
          <!-- <div> -->
            <div class="tab_box textStart martop15" v-for="(item,index) in fileData" :key="index" @click="DownLoad(index,item)">
              <div class="icon1">{{item.docFormat}}</div>
              <div class="colorText">{{item.docName}}</div>
            </div>
          <!-- </div> -->
       </div>
       <div  class="showFile" v-if="isShow">
         <img :src="srcImg" alt="" style="width:100%;height:100%;" v-if="srcImg"/>
         <p class="title" v-if="!srcImg">暂不支持该文件预览</p>
         <div class="closebtn" @click="closePop"></div>
       </div>
  </div>
</template>
<script>
 import MyApis from "../../../apis";
 import { getDocList } from "../../../apis/src/Query";
 export default {
    data() {
      return {
        date:"",
        taskTabIndex:0,
        tabPosition:'left',
        activeInd:"0",
        fileData:[],
        FileName:"",
        srcImg:"",
        isShow:false
      };
    },
  created(){
      this.getTList();
    },
    methods: {
     showLoading(text) {
        this.$emit('loading', text);
      },
    hideLoading() {
      this.$emit('loadingFinish');
     },
     closePop(){
        this.isShow = false;
     },
     getTList() {
        this.showLoading('加载中...');
        getDocList({docName:this.FileName,docCategorization: 'drawing', pageNum: 1, pageSize:20}).then(res =>{
          this.hideLoading();
          if(res.code == 200){
            this.fileData = res.rows
          }else{
            this.errmsg(res.msg? res.msg : "服务异常，请联系管理员！");
          }
        })
        new MyApis.FileApi()
            .GetFileList(params)
            .then((r) => {
            var data = r.data.Data;
            console.log(data)
            that.fileData = data.FileList;
            this.hideLoading();
            })
            .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
            });
    },
    DownLoad(index, row) {
      let _this=this;
      var downloadpath = row.downloadPath;
      console.log(row)
      console.log(downloadpath)
      if (row.docFormat !== 'jpg' && row.docFormat !== 'png' && row.docFormat !== 'gif') {
        // window.location.href = downloadpath;
        _this.srcImg ="";
        this.isShow = true;
      } else {
        // window.open(downloadpath);
         _this.srcImg = downloadpath;
        this.isShow = true;
      }   
      console.log(_this.srcImg)  
    }

  }
};
</script>
<style lang="scss" scoped>
.flexout{
    display:flex;
    align-items:center;
    justify-content:flex-start;
    margin-bottom:10px;
    .line{
      display: inline-block;
      width:4px;
      height:22px;
      background: #00c6ff;
      margin-right:10px; 
    }
    .text{
      font-size: 18px;
      line-height: 26px;
      color: #23c3ff;
    }
}
.tab_box{ 
    display:flex;
    align-items: center;
}
.betw{
   justify-content: space-between; 
}
.textStart{
  justify-content: flex-start;
}
.topOne{ 
    width:41.6%;
    height:auto;
    line-height: 50px;  
    font-size: 0.2rem;
    text-align: right;
    padding-right:2.6rem;
    box-sizing: border-box;
    cursor: pointer;
}
.task_tabActive{
  font-weight:bold;
	font-size:0.14rem;
	line-height: 24px;
	letter-spacing: 0px;
	color: #23c3ff;
  border-bottom: 2px solid #00c6ff;
    cursor: pointer;
}
.task_tabOne{
  font-weight:bold;
	font-size:0.14rem;
	line-height: 24px;
	letter-spacing: 0px;
	color: #e4f7ff;
	opacity: 0.5;
  cursor: pointer;
}
.icon1{
  // width: 3.8rem;
  height: 2.4rem;
  border: solid 1px #2bc2ff;
  text-align: center;
  // line-height: 24px;
  margin-right:10px;
  font-size: 1.4rem;
	font-weight: bold;
	font-stretch: normal;
	line-height: 2.4rem;
	color: #2ac1ff;
  padding:0 0.6rem;
}
.marginr15{
  margin-right:15px;
}

.colorText{
  font-weight: bold;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: 0px;
	color: #2ac1ff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.martop15{
  margin-top: 15px;
}
.project_box{
    width:100%;
    height:100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}
.top1{
    height:22px;
}
.top2{
    height:55px;
}
.content{
    flex:1;
    overflow: auto;
}
.showFile{
   width:900px;
   height:460px;
   padding:10px;
   box-sizing: border-box;
   position:fixed;
   left:50%;
   margin-left:-450px;
   top:80px;
   	background-color:rgba(15,36,69,0.8);
  border: solid 1px #2bc2ff;
  z-index:9999;
}
.closebtn{
  width:16px;
  height:16px;
  background: url("../../../../../../assets/close.png");
  position: absolute;
  right:20px;
  top:20px;
  z-index: 999;
}
.title{
  font-size: 16px;
  margin-top:90px;
  text-align: center;
  color: #2ac1ff;
}
</style>